import {
  FETCH_WELD_DATA,
  SET_WELD_DATA,
  SET_WELD_DATA_FAILURE,
  FETCH_WELD_PASSES,
  SET_WELD_PASSES,
  SET_WELD_PASSES_FAILURE,
  CLEAR_WELD_PASSES,
  FETCH_ZONE_VIEW,
  SET_ZONE_VIEW,
  SET_ZONE_VIEW_FAILURE,
  CLEAR_ZONE_VIEW,
  FETCH_TILT_VIEW,
  SET_TILT_VIEW,
  SET_TILT_VIEW_FAILURE,
  CLEAR_TILT_VIEW,
  FETCH_PASS_VIEW_DETAILS,
  SET_PASS_VIEW_DETAILS,
  SET_PASS_VIEW_DETAILS_FAILURE,
  CLEAR_PASS_VIEW_DETAILS,
  FETCH_TILT_VIEW_DETAILS,
  FETCH_ZONE_VIEW_DETAILS,
  SET_ZONE_VIEW_DETAILS,
  SET_ZONE_VIEW_DETAILS_FAILURE,
  CLEAR_ZONE_VIEW_DETAILS,
  FETCH_WELD_SEGMENT_VIEW,
  SET_WELD_SEGMENT_VIEW,
  SET_WELD_SEGMENT_VIEW_FAILURE,
  CLEAR_WELD_SEGMENT_VIEW,
  FETCH_WELD_SEGMENT_DETAIL,
  SET_WELD_SEGMENT_DETAIL,
  SET_WELD_SEGMENT_DETAIL_FAILURE,
  CLEAR_WELD_SEGMENT_DETAIL,
  SET_CURRENT_PROJECT,
  CLEAR_CURRENT_PROJECT,
  FETCH_PROJECTS,
  SET_PROJECTS,
  SET_PROJECTS_FAILURE,
  SET_SELECTED_PROJECT,
  FETCH_SLOGS_REQUEST,
  FETCH_SLOGS_SUCCESS,
  FETCH_SLOGS_FAILURE,
  GENERATE_REPORT_REQUEST,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_FAILURE,
  CLEAR_REPORT_STATUS,
  CLEAR_WELD_DATA,
  FETCH_LIMITS_DATA,
  SET_LIMITS_DATA,
  SET_LIMITS_DATA_FAILURE,
  CLEAR_LIMITS_DATA,
  UPDATE_STATUS_CONFIGURATION,
  UPDATE_STATUS_CONFIGURATION_SUCCESS,
  UPDATE_STATUS_CONFIGURATION_FAILURE,
  FETCH_MANUAL_STATUS_CONFIGURATION,
  SET_MANUAL_STATUS_CONFIGURATION,
  SET_MANUAL_STATUS_CONFIGURATION_FAILURE,
  UPDATE_MANUAL_STATUS_CONFIGURATION,
  UPDATE_MANUAL_STATUS_CONFIGURATION_SUCCESS,
  UPDATE_MANUAL_STATUS_CONFIGURATION_FAILURE,
  CLEAR_MANUAL_STATUS_CONFIGURATION,
  CLEAR_ALL_WELD_VIEWS,
  ASSIGN_PIPE_TO_WELD,
  ASSIGN_PIPE_TO_WELD_SUCCESS,
  ASSIGN_PIPE_TO_WELD_FAILURE,
  ASSIGN_JOB_NUMBER_TO_PIPE,
  ASSIGN_JOB_NUMBER_TO_PIPE_SUCCESS,
  ASSIGN_JOB_NUMBER_TO_PIPE_FAILURE,
  UPDATE_WELD_NUMBER,
  UPDATE_WELD_NUMBER_SUCCESS,
  UPDATE_WELD_NUMBER_FAILURE,
  CLEAR_UPDATE_WELD_NUMBER_STATUS,
  RENAME_JOB_NUMBER,
  RENAME_JOB_NUMBER_SUCCESS,
  RENAME_JOB_NUMBER_FAILURE,
  MERGE_PASSES,
  MERGE_PASSES_SUCCESS,
  MERGE_PASSES_FAILURE,
  CLEAR_MERGE_PASSES_STATUS,
  CLEAR_RESTORE_MERGED_PASSES_STATUS
} from './types';

// Action creators
export const fetchWeldData = (projectId, projectName = null, jobNumber = null, pipeId = null) => {
  const pipeIds = Array.isArray(pipeId) ? pipeId : undefined;
  return {
    type: FETCH_WELD_DATA,
    projectId,
    projectName,
    jobNumber,
    pipeId: pipeIds ? null : pipeId,
    pipeIds,
  };
};

/** Explicit multi-pipe fetch for Weld Analytics. */
export const fetchWeldDataForPipes = (projectId, projectName = null, pipeIds = [], jobNumber = null) => ({
  type: FETCH_WELD_DATA,
  projectId,
  projectName,
  jobNumber,
  pipeId: null,
  pipeIds,
});

export const setWeldData = (weldData, statusCalculationMethod) => ({
  type: SET_WELD_DATA,
  weldData,
  statusCalculationMethod
});

export const setWeldDataFailure = (error) => ({
  type: SET_WELD_DATA_FAILURE,
  error
});

export const fetchWeldPasses = (projectId, projectName = null, weldNumber, jobNumber = null) => ({
  type: FETCH_WELD_PASSES,
  projectId,
  projectName,
  weldNumber,
  jobNumber
});

export const setWeldPasses = (weldPasses) => ({
  type: SET_WELD_PASSES,
  weldPasses
});

export const setWeldPassesFailure = (error) => ({
  type: SET_WELD_PASSES_FAILURE,
  error
});

export const clearWeldPasses = () => ({
  type: CLEAR_WELD_PASSES
});

export const fetchZoneView = (projectId, projectName = null, weldNumber, jobNumber = null) => ({
  type: FETCH_ZONE_VIEW,
  projectId,
  projectName,
  weldNumber,
  jobNumber
});

export const setZoneView = (zoneViewData) => ({
  type: SET_ZONE_VIEW,
  zoneViewData
});

export const setZoneViewFailure = (error) => ({
  type: SET_ZONE_VIEW_FAILURE,
  error
});

export const clearZoneView = () => ({
  type: CLEAR_ZONE_VIEW
});

export const fetchTiltView = (projectId, projectName = null, weldNumber, jobNumber = null) => ({
  type: FETCH_TILT_VIEW,
  projectId,
  projectName,
  weldNumber,
  jobNumber
});

export const setTiltView = (tiltViewData) => ({
  type: SET_TILT_VIEW,
  tiltViewData
});

export const setTiltViewFailure = (error) => ({
  type: SET_TILT_VIEW_FAILURE,
  error
});

export const clearTiltView = () => ({
  type: CLEAR_TILT_VIEW
});

export const fetchPassViewDetails = (projectId, projectName = null, welduid_s_event_torch, viewType = 'Pass', torchType = 'Lead') => {
  return {
    type: FETCH_PASS_VIEW_DETAILS,
    projectId,
    projectName,
    welduid_s_event_torch,
    viewType,
    torchType
  };
};

export const fetchTiltViewDetails = (projectId, projectName = null, welduid_s_event_torch, viewType = 'Tilt', torchType = 'Lead', tiltStart, tiltEnd) => {
  return {
    type: FETCH_TILT_VIEW_DETAILS,
    projectId,
    projectName,
    welduid_s_event_torch,
    viewType,
    torchType,
    tiltStart,
    tiltEnd
  };
};

export const setPassViewDetails = (passViewDetails) => ({
  type: SET_PASS_VIEW_DETAILS,
  passViewDetails
});

export const setPassViewDetailsFailure = (error) => ({
  type: SET_PASS_VIEW_DETAILS_FAILURE,
  error
});

export const clearPassViewDetails = () => ({
  type: CLEAR_PASS_VIEW_DETAILS
});

export const fetchWeldSegmentView = (projectId, projectName = null, welduid_s_event_torch, viewType = 'Pass', torchType = 'Lead') => ({
  type: FETCH_WELD_SEGMENT_VIEW,
  projectId,
  projectName,
  welduid_s_event_torch,
  viewType,
  torchType,
});

export const setWeldSegmentView = (weldSegmentView) => ({
  type: SET_WELD_SEGMENT_VIEW,
  weldSegmentView,
});

export const setWeldSegmentViewFailure = (error) => ({
  type: SET_WELD_SEGMENT_VIEW_FAILURE,
  error,
});

export const clearWeldSegmentView = () => ({
  type: CLEAR_WELD_SEGMENT_VIEW,
});

export const fetchWeldSegmentDetail = (projectId, projectName = null, welduid_s_event_torch, welduid_t_event_torch, viewType = 'Pass', torchType = 'Lead') => ({
  type: FETCH_WELD_SEGMENT_DETAIL,
  projectId,
  projectName,
  welduid_s_event_torch,
  welduid_t_event_torch,
  viewType,
  torchType,
});

export const setWeldSegmentDetail = (weldSegmentDetail) => ({
  type: SET_WELD_SEGMENT_DETAIL,
  weldSegmentDetail,
});

export const setWeldSegmentDetailFailure = (error) => ({
  type: SET_WELD_SEGMENT_DETAIL_FAILURE,
  error,
});

export const clearWeldSegmentDetail = () => ({
  type: CLEAR_WELD_SEGMENT_DETAIL,
});

export const fetchZoneViewDetails = (projectId, projectName = null, welduid_s_event_torch, viewType = 'Zone', torchType = 'Lead', zoneName) => ({
  type: FETCH_ZONE_VIEW_DETAILS,
  projectId,
  projectName,
  welduid_s_event_torch,
  viewType,
  torchType,
  zoneName
});

export const setZoneViewDetails = (zoneViewDetails) => ({
  type: SET_ZONE_VIEW_DETAILS,
  zoneViewDetails
});

export const setZoneViewDetailsFailure = (error) => ({
  type: SET_ZONE_VIEW_DETAILS_FAILURE,
  error
});

export const clearZoneViewDetails = () => ({
  type: CLEAR_ZONE_VIEW_DETAILS
});

// New action creators for project management
export const setCurrentProject = (project) => ({
  type: SET_CURRENT_PROJECT,
  project
});

export const clearCurrentProject = () => ({
  type: CLEAR_CURRENT_PROJECT
});

// New action creators for projects API
export const fetchProjects = () => ({
  type: FETCH_PROJECTS
});

export const setProjects = (projects) => ({
  type: SET_PROJECTS,
  projects
});

export const setProjectsFailure = (error) => ({
  type: SET_PROJECTS_FAILURE,
  error
});

export const setSelectedProject = (project) => ({
  type: SET_SELECTED_PROJECT,
  project
});

// Slog data action creators
export const fetchSlogsData = (projectId, projectName) => ({
  type: FETCH_SLOGS_REQUEST,
  payload: { projectId, projectName }
});

export const setSlogsData = (data) => ({
  type: FETCH_SLOGS_SUCCESS,
  payload: data
});

export const setSlogsDataFailure = (error) => ({
  type: FETCH_SLOGS_FAILURE,
  payload: error
});

// Report generation action creators
export const generateReport = (reportType, projectId, emailAddress, weldNumbers = null, startDate = null, endDate = null, reportVersion = 'v1') => {
  const payload = {
    reportType,
    projectId,
    emailAddress,
    startDate,
    endDate,
    reportVersion
  };
  
  // Only include weldNumbers in payload if it has a value
  if (weldNumbers && weldNumbers.length > 0) {
    payload.weldNumbers = weldNumbers;
  }
  
  return {
    type: GENERATE_REPORT_REQUEST,
    payload
  };
};

export const setReportGenerationSuccess = (data) => ({
  type: GENERATE_REPORT_SUCCESS,
  payload: data
});

export const setReportGenerationFailure = (error) => ({
  type: GENERATE_REPORT_FAILURE,
  payload: error
});

export const clearReportStatus = () => ({
  type: CLEAR_REPORT_STATUS
});

export const clearWeldData = () => ({
  type: CLEAR_WELD_DATA
});

// Limits data action creators
export const fetchLimitsData = (projectId) => ({
  type: FETCH_LIMITS_DATA,
  projectId
});

export const setLimitsData = (limitsData) => ({
  type: SET_LIMITS_DATA,
  limitsData
});

export const setLimitsDataFailure = (error) => ({
  type: SET_LIMITS_DATA_FAILURE,
  error
});

export const clearLimitsData = () => ({
  type: CLEAR_LIMITS_DATA
});

export const updateStatusConfiguration = (payload) => {
  return {
    type: UPDATE_STATUS_CONFIGURATION,
    payload
  };
};

export const updateStatusConfigurationSuccess = (data) => ({
  type: UPDATE_STATUS_CONFIGURATION_SUCCESS,
  payload: data
});

export const updateStatusConfigurationFailure = (error) => ({
  type: UPDATE_STATUS_CONFIGURATION_FAILURE,
  payload: error
});

export const fetchManualStatusConfiguration = (projectId, jobNumber = null) => ({
  type: FETCH_MANUAL_STATUS_CONFIGURATION,
  projectId,
  jobNumber,
});

export const setManualStatusConfiguration = (data) => ({
  type: SET_MANUAL_STATUS_CONFIGURATION,
  payload: data,
});

export const setManualStatusConfigurationFailure = (error) => ({
  type: SET_MANUAL_STATUS_CONFIGURATION_FAILURE,
  payload: error,
});

export const updateManualStatusConfiguration = (projectId, payload) => ({
  type: UPDATE_MANUAL_STATUS_CONFIGURATION,
  projectId,
  payload,
});

export const updateManualStatusConfigurationSuccess = (data) => ({
  type: UPDATE_MANUAL_STATUS_CONFIGURATION_SUCCESS,
  payload: data,
});

export const updateManualStatusConfigurationFailure = (error) => ({
  type: UPDATE_MANUAL_STATUS_CONFIGURATION_FAILURE,
  payload: error,
});

export const clearManualStatusConfiguration = () => ({
  type: CLEAR_MANUAL_STATUS_CONFIGURATION,
});

// Clear all weld views data (passes, zone view, tilt view, and their details)
export const clearAllWeldViews = () => ({
  type: CLEAR_ALL_WELD_VIEWS
});

// Assign pipe to weld action creators
export const assignPipeToWeld = (payload) => ({
  type: ASSIGN_PIPE_TO_WELD,
  payload
});

export const assignPipeToWeldSuccess = (data) => ({
  type: ASSIGN_PIPE_TO_WELD_SUCCESS,
  payload: data
});

export const assignPipeToWeldFailure = (error) => ({
  type: ASSIGN_PIPE_TO_WELD_FAILURE,
  payload: error
});

// Assign job number to pipe action creators
export const assignJobNumberToPipe = (payload) => ({
  type: ASSIGN_JOB_NUMBER_TO_PIPE,
  payload
});

export const assignJobNumberToPipeSuccess = (data) => ({
  type: ASSIGN_JOB_NUMBER_TO_PIPE_SUCCESS,
  payload: data
});

export const assignJobNumberToPipeFailure = (error) => ({
  type: ASSIGN_JOB_NUMBER_TO_PIPE_FAILURE,
  payload: error
});

// Update weld number action creators
export const updateWeldNumber = (payload) => ({
  type: UPDATE_WELD_NUMBER,
  payload
});

export const updateWeldNumberSuccess = (data) => ({
  type: UPDATE_WELD_NUMBER_SUCCESS,
  payload: data
});

export const updateWeldNumberFailure = (error) => ({
  type: UPDATE_WELD_NUMBER_FAILURE,
  payload: error
});

export const clearUpdateWeldNumberStatus = () => ({
  type: CLEAR_UPDATE_WELD_NUMBER_STATUS
});

export const renameJobNumber = (payload) => ({
  type: RENAME_JOB_NUMBER,
  payload
});

export const renameJobNumberSuccess = (data) => ({
  type: RENAME_JOB_NUMBER_SUCCESS,
  payload: data
});

export const renameJobNumberFailure = (error) => ({
  type: RENAME_JOB_NUMBER_FAILURE,
  payload: error
});

// Merge passes action creators
export const mergePasses = (payload) => ({
  type: MERGE_PASSES,
  payload
});

export const mergePassesSuccess = (data) => ({
  type: MERGE_PASSES_SUCCESS,
  payload: data
});

export const mergePassesFailure = (error) => ({
  type: MERGE_PASSES_FAILURE,
  payload: error
});

// Unmerge passes (restore) action creators
export const restoreMergedPasses = (payload) => ({
  type: 'RESTORE_MERGED_PASSES',
  payload
});

export const restoreMergedPassesSuccess = (data) => ({
  type: 'RESTORE_MERGED_PASSES_SUCCESS',
  payload: data
});

export const restoreMergedPassesFailure = (error) => ({
  type: 'RESTORE_MERGED_PASSES_FAILURE',
  payload: error
});

// Clear merge/restore status so navigating back doesn't show previous loading/success/error
export const clearMergePassesStatus = () => ({
  type: CLEAR_MERGE_PASSES_STATUS
});

export const clearRestoreMergedPassesStatus = () => ({
  type: CLEAR_RESTORE_MERGED_PASSES_STATUS
});